<template>
  <div class="ownerLayout">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ownerLayout',
  data(){
    return {

    }
  },
  created(){

  },
  mounted(){




  },
  methods:{

  }
}
</script>

<style lang="less" scoped>
.ownerLayout{
  position: relative;
  width: 100%;
  height: 100%;
}
</style>